import api from '@/utils/api';

/**
 * Update user
 * @param {string} id user id
 * @param {object} userData - The user data
 * @returns {Promise}
 */
const updateUserApi = (id, userData) => api.patch(`/user/${id}`, userData);

export default updateUserApi;
